export default {
  "container": "_container_nvl07w",
  "main": "_main_nvl07w",
  "logo": "_logo_nvl07w",
  "content": "_content_nvl07w",
  "side": "_side_nvl07w"
};
